import SoftTokensActivateTokenCompletionPage from "components/pages/SoftTokensActivateTokenCompletionPage";

/**
 * @name CaptureSoftTokenActivationActivateTokenContinue
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenContinue(props) {
    return <SoftTokensActivateTokenCompletionPage />;
}